import React, {PropTypes as T} from 'react';
import translate from '../../../../utils/translate';
import basketActions from '../../../../actions/basket';
import Button from '../../../common/button';
import SIM from '../../../../sim/core';
const mapActions = SIM.actions.map;

export default class GASubmitBtn extends React.Component {
  static propTypes = {
    section:       T.object,
    sectionBasket: T.object,
    disabled:      T.bool
  };

  updateGASection = () => {
    basketActions.updateGASection(this.props.section, this.props.sectionBasket);
    mapActions.emit(mapActions.EVENTS.SECTION_RESET);
  };

  render () {
    return (
      <Button
        className="gasubmit__btn"
        primary
        flex
        disabled={this.props.disabled}
        onClick={this.updateGASection}
        data-component="gasubmit">
        {translate('ismModule', 'ADD_TO_BASKET')}
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/generaladmission/gasubmit/index.js